export const WF_PO_FORM_FIELDS = [
    {
        label: 'Bill Address',
        sectionCode: 'labels_billaddress',
        fields: [
            {
                settingFieldName: 'vendorname',
                formFieldname: 'vendorname'
            },
            
        ]
    },
    {
        label: 'Payments',
        sectionCode: 'labels_section',
        fields: [
            {
                settingFieldName: 'payment term',
                formFieldname: 'paymentterm'
            },
            {
                settingFieldName: 'payment method',
                formFieldname: 'paymentmethod'
            },
            {
                settingFieldName: 'shippingterm',
                formFieldname: 'shippingterm'
            },
            {
                settingFieldName: 'shippingmethod',
                formFieldname: 'shippingmethod'
            },
            {
                settingFieldName: 'salesrep',
                formFieldname: 'salesrep'
            }
        ]
    },
    {
        label: 'Misc',
        sectionCode: 'labels_misc',
        fields: [
            {
                settingFieldName: 'date',
                formFieldname: 'date'
            },
            {
                settingFieldName: 'status',
                formFieldname: 'status'
            },
            {
                settingFieldName: 'createdby',
                formFieldname: 'createdby'
            },
            {
                settingFieldName: 'referenceno',
                formFieldname: 'referenceno'
            }
        ]
    },
    {
        label: 'Table Footer',
        sectionCode: 'labels_footer',
        fields: [
            {
                settingFieldName: 'discount',
                formFieldname: 'discount'
            },
            {
                settingFieldName: 'tax',
                formFieldname: 'tax'
            },
            {
                settingFieldName: 'adddiscount',
                formFieldname: 'adddiscount'
            },
            {
                settingFieldName: 'shipping',
                formFieldname: 'shipping'
            },
            {
                settingFieldName: 'freeshipping',
                formFieldname: 'freeshipping'
            }
        ]
    }
];